export const SEARCH_VISIBILITY_THRESHOLD = 7;
